export const businessCreationPath = '/business-creation';
